/**
 * Which sidebar rows carry a count badge, and what they count. Pure, so the
 * rule is unit-tested without mounting the sidebar (its hooks reach for the
 * profile, tasks and onboarding queries).
 *
 *   tasks               open tasks (the Tasks page's inbox total)
 *   production-records  campus-days whose production record is incomplete
 *                       (the Production Records page's campus-tab counts, summed)
 *
 * Zero and negative counts render no badge: a badge is a call to action, and
 * "0" would read as one.
 */

export interface SidebarBadgeCounts {
  taskCount: number
  pendingProductionDays: number
}

export function sidebarRowBadgeCount(slug: string, counts: SidebarBadgeCounts): number | null {
  const count = slug === 'tasks' ? counts.taskCount : slug === 'production-records' ? counts.pendingProductionDays : 0
  return count > 0 ? count : null
}
